import React from 'react'
import styles from './Types.module.scss'
import { motion } from "framer-motion"
import img_1 from '../../image/Types/img_1.png'
import img_2 from '../../image/Types/img_2.png'
import img_3 from '../../image/Types/img_3.png'
import img_4 from '../../image/Types/img_4.png'

const titleAnimation = {
    hidden: {
        y: 200,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .5 }
    }
}

const cardAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .7}
    } 
}



const Types = () => {

    return (
        <motion.section 
            className={styles.main}
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.1, once: true}}
            >
            <div className={styles.box}>
                <motion.h2 className={styles.title} variants={titleAnimation}>Мы производим следующие <span> виды&#160;навесов</span></motion.h2>
                <motion.ul className={styles.list}>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <img className={styles.image} src={img_1} alt='кровля'/>
                        <p className={styles.text}>Односкатные</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <img className={styles.image} src={img_2} alt='кровля'/>
                        <p className={styles.text}>Двухскатные</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <img className={styles.image} src={img_3} alt='кровля'/>
                        <p className={styles.text}>Полуарочные</p>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <img className={styles.image} src={img_4} alt='кровля'/>
                        <p className={styles.text}>Арочные</p>
                    </motion.li>
                </motion.ul>
            </div>
        </motion.section>
    )
}

export default Types